import React from 'react'
import '../../styles/index.scss'
import '../../styles/navbar/styles.scss'
import PropTypes from 'prop-types'
import autobind from '../../lib/autobind'
import AriaModal from 'react-aria-modal'
import Link from '../Link'
import LoginButton from '../LoginButton'
class MobileNav extends React.Component {
  constructor (props) {
    super(props)
    autobind(this)
    this.state = {
      isOpen: false,
      hasEntered: false
    }
  }

  getChildContext () {
    return {
      openMenu: this.handleOpenMenu,
      closeMenu: this.handleCloseMenu
    }
  }

  handleOpenMenu () {
    this.setState({ isOpen: true })
  }

  handleCloseMenu () {
    return new Promise((resolve) => {
      this.setState({ hasEntered: false }, () => {
        setTimeout(() => {
          this.setState({ isOpen: false }, resolve)
        }, 300)
      })
    })
  }

  componentDidMount () {
    if (this.context.router) {
      this.unlisten = this.context.router.listen(this.handleCloseMenu)
    }
  }

  componentWillUnmount () {
    if (this.unlisten) this.unlisten()
  }

  handleOnEnter () {
    this.setState({ hasEntered: true })
  }

  render () {
    const { REACT_APP_DASHBOARD_LINK } = window.env
    let modalClassName = 'modal-content--animated'
    let underlayClassName = 'modal-underlay--animated'
    if (this.state.hasEntered) {
      modalClassName += ' modal-content--animated--has-entered'
      underlayClassName += ' modal-underlay--animated--has-entered'
    }
    return (
      <div className='mobile-nav'>
        <div className='mobile-navbar'>
          <LoginButton>
            <a className='mobile-nav__apps-link' href={REACT_APP_DASHBOARD_LINK}>
              Apps
            </a>
          </LoginButton>
          <button onClick={this.handleOpenMenu} className='mobile-nav__menu-button'>
            Menu
          </button>
        </div>

        <AriaModal
          mounted={this.state.isOpen}
          onEnter={this.handleOnEnter}
          onExit={this.handleCloseMenu}
          underlayClass={underlayClassName}
          titleText='site navigation menu'
        >
          <nav
            className={`js-mobile-nav mobile-nav__overlay ${modalClassName}`}
            tabIndex='0'
          >
            <button className='mobile-nav__close-btn' onClick={this.handleCloseMenu}>
              Close
            </button>
            <div className='mobile-nav__logo'>
              <h1 className='mobile-nav__logo-h1'>
                <Link to='/' className='mobile-nav__logo-link'>
                  Foundation Medicine
                </Link>
              </h1>
            </div>
          </nav>
        </AriaModal>
      </div>
    )
  }
}

MobileNav.childContextTypes = {
  openMenu: PropTypes.func,
  closeMenu: PropTypes.func
}

export default MobileNav
